import {timeNow} from './utils';

export class Clock {
    startTime = 0;
    lastUpdateTime = 0;
    delta = 0;

    constructor() {
        this.reset();
    }

    reset() {
        this.startTime = timeNow();
        this.lastUpdateTime = 0;
    }

    get time() {
        return timeNow() - this.startTime;
    }

    update() {
        const now = this.time;
        this.delta = now - this.lastUpdateTime;
        this.lastUpdateTime = now;
        return this.delta;
    }
}
